// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import { DurationField } from './DurationField';

export default DurationField;
export type { DurationValueOptions } from './DurationField';
